import React from "react";
import "./App.css";
import ASLForm from "./components/ASLForm.js";

function App() {
  return (
    <div className="main-container">
      <div className="main-container-header">
        <table>
          <tbody>
            <tr>
              <td>
                <div className="gen-asl-logo">
                  <img
                    src={require("./assets/gen-asl-logo.png")}
                    alt="gen-asl-logo"
                  />
                </div>
              </td>
              <td>
                Generative AI Application To Produce American Sign Language
                Avatar <span style={{fontSize: '0.7rem', color: '#ff00ff'}}>(Sync v2.0)</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>&nbsp;</div>
      <ASLForm />
    </div>
  );
}
export default App;
